import React, { useEffect, useState, useCallback, Fragment } from 'react';
import lodash, { isEmpty } from 'lodash';
import { connect } from 'react-redux';
import { Box } from '@material-ui/core';
import { Link } from 'react-router';
import { getDashboardDetailsBinderStudiesAdminBinders, handleBinderCustomColumns, getBinderCustomColumns } from '../../actions/dashboard';
import StudyUsersTeamTable from '../../../pages/studyOverview/containers/StudyUsers/StudyUsersTeamTable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faThumbtack } from '@fortawesome/free-solid-svg-icons';
import { bindersInitialStateV4, bindersInitialStateV4NoAccess } from './bindersInitialStateV4';
import styles from './StudyBinders.scss';
import { setBinderPinAction } from 'common/actions/pinnedBinderToggle';
import { gatherBinderStudiesTableData } from './HelperFunctions/buildBinderStudiesRows';
import { hardCodedColumnsGenerator } from './HelperFunctions/formatDate';
import { customColumns } from './HelperFunctions/defaultCustomColumns';
import { binderStudiesColumnsGenerator } from './HelperFunctions/binderStudiesColumns';
import { customFilterColumnsGenerator } from './HelperFunctions/customFilterColumnGenerator';
import { getBinderLink, goBackHome } from './HelperFunctions/openStudyBinders';
import CreateBinder from '../CreateBinderV4/index';
import { createNewBinderPredicate } from 'common/permissions/predicates';
import { Conditional } from '../../../common/components/layout/index';


const DEFAULT_FILTER = { search: '', filter: {}, sort: { key: 'name', value: 'ASC' }, customizedColumns: customColumns, initial: true };



export function AdministrativeBinders({ getDashboardDetailsBinderStudiesAdminBinders,
    binderStudies,
    institutionId,
    currentUserId,
    handleBinderCustomColumns,
    getBinderCustomColumns,
    binderCustomColumns,
    binderStudiesTotalCount,
    binderStudiesSponsors,
    binderStudiesSiteNumbers,
    binderStudiesBinderTypes,
    binderStudiesContacts,
    binderStudiesPrincipalInvestigators,
    binderStudiesSites,
    binderStudiesCros,
    binderStudiesDepartments,
    binderStudiesDiseaseGroups,
    pinnedBinderIds,
    setBinderPinAction,
    loadingBinderStudies,
    canCreateBinder,
    ...props
}) {
    const [filterRecord, setFilterRecord] = useState(DEFAULT_FILTER);
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [paginationdata, setPagination] = useState({ limit: 25, offset: 0, totalCount: 0 });
    const [isZeroState, setIsZeroState] = useState(false);
    const [initialLoading, setInititalLoading] = useState(true);
    const [pinnedBinderIdsState, setPinnedBinderIdsState] = useState(pinnedBinderIds);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [rowData, setRowData] = useState({});
    const [isDraftView, setIsDraftView] = useState(false);
    const [draftBinderId, setDraftBinderId] = useState(null);

    const debouncedHandleBinderCustomColumnsCall = useCallback(lodash.debounce((currentUserId, institutionId, customizedColumns) =>
        handleBinderCustomColumns(currentUserId, institutionId, customizedColumns), 1000), []
    );

    useEffect(() => {
        const { pathname } = props.location;
        let _draftBinderId = '';

        pathname.split('/').forEach((item, index) => {
            if (item === 'draft') {
                _draftBinderId = pathname.split('/')[index + 1];
            }
        });

        if (_draftBinderId) {
            setIsDraftView(true);
            setDraftBinderId(_draftBinderId);
        } else {
            setIsDraftView(false);
        }
    }, []);

    useEffect(() => {
        if (pinnedBinderIds.length)
            setPinnedBinderIdsState(pinnedBinderIds);
    }, [pinnedBinderIds]);



    const createBinderFunction = () => {
        return setIsDrawerOpen(true);
    };

    const closeCreateBinder = () => {
        if (isDraftView) {
            setIsDrawerOpen(false);
        }
        goBackHome();
        setRowData({});
    };

    const onPinStudyBinder = async (data) => {
        let resData = await setBinderPinAction(data.isBinder ? data.id : data.binderId, !pinnedBinderIdsState.includes(data.isBinder ? data.id : data.binderId));
        let pinnedBinderIdsData = pinnedBinderIdsState;
        let binderPinData = resData.payload && resData.payload.binderPinData.isPinned;

        if (binderPinData)
            pinnedBinderIdsData.push(resData.payload.binderPinData.binderId);
        else
            pinnedBinderIdsData = pinnedBinderIdsData.filter(f => f !== resData.payload.binderPinData.binderId);

        setPinnedBinderIdsState([...pinnedBinderIdsData]);
    };

    const buildBinderStudiesColumns = (customColumns, filter) => {
        const columnWidth = '10%';
        const minColumnWidth = '10%';
        const maxColumnWidth = 0;
        const commonHeaderStyle = {
            width: columnWidth,
            minWidth: minColumnWidth,
            maxWidth: maxColumnWidth,
        };

        const binderStudiesColumns = binderStudiesColumnsGenerator(binderCustomColumns !== null ? binderCustomColumns : filterRecord.customizedColumns);
        const createButton = {
            title: 'createButton',
            field: 'createButton',
            createButton: true,
            hidden: true,
            isCreateAllowed: canCreateBinder,
            execute: createBinderFunction,
            label: 'Create Binder',
            icon: <FontAwesomeIcon icon={faPlus} />,
        };
        const customColumnRecord =
        {
            title: 'Customize',
            field: 'customize',
            hidden: true,
            headerStyle: commonHeaderStyle,
            cellStyle: {
                width: columnWidth,
                minWidth: minColumnWidth,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                color: 'var(--blue-500, #2057AD)',
            },
            customize: true,
            customizeItems: binderCustomColumns,
        };

        const displayColumns = [];


        const hardCodedFilterColumns = hardCodedColumnsGenerator(binderCustomColumns);
        const customFilterColumns = customFilterColumnsGenerator(binderCustomColumns, binderStudiesSponsors, binderStudiesCros, binderStudiesBinderTypes, binderStudiesDiseaseGroups, binderStudiesContacts, binderStudiesSites, binderStudiesDepartments, binderStudiesSiteNumbers, binderStudiesPrincipalInvestigators);

        if (customColumns && customColumns.length > 0) {
            //sort the filter by title from A-Z
            const filterColumns = [...hardCodedFilterColumns, ...customFilterColumns];

            filterColumns.sort((a, b) => {
                const titleA = a.title.toUpperCase();
                const titleB = b.title.toUpperCase();
                if (titleA < titleB) {
                    return -1;
                }
                if (titleA > titleB) {
                    return 1;
                }
                return 0;
            });
            displayColumns.push(...filterColumns);
            displayColumns.push(
                {
                    title: 'Activation Date',
                    field: 'activationDate',
                    hidden: true,
                    toolbarSort: 'DESC',
                    toolbarSortByPostFix: [' (newest)', ' (oldest)'],
                    toolbarDefaultSort: false,
                    singleSort: false
                },
                {
                    title: 'Name',
                    field: 'name',
                    key: 'name',
                    searchPlaceholder: 'Binders',
                    hidden: false,
                    headerStyle: {
                        width: '40%',
                        minWidth: '40%',
                        maxWidth: '40%',
                        paddingLeft: '46px'
                    },
                    cellStyle: {
                        width: '40%',
                        maxWidth: 'none',
                    },
                    toolbarSearch: true,
                    toolbarSort: 'ASC',
                    toolbarDefaultSort: true,
                    render: rowData => (
                        <Box display="flex" alignItems="center" >
                            <Box className={styles.pinIconContainer}>
                                <FontAwesomeIcon
                                    icon={faThumbtack}
                                    className={styles.pinIcon}
                                    color={`${pinnedBinderIdsState.includes(rowData.isBinder ? rowData.id : rowData.binderId) && '#2057AD'}`}
                                    onClick={() => onPinStudyBinder(rowData)}
                                />
                            </Box>
                            <Link onClick={e => e.stopPropagation()} underline="none" href={`${getBinderLink(rowData, props.location.pathname)}`}>
                                <Box
                                    className={styles.firstCol}
                                    title={rowData.name}
                                >{rowData.name}</Box>
                            </Link>
                        </Box >
                    )
                },
                {
                    title: binderCustomColumns && binderCustomColumns.find(column => column.key === 'renewal_date').label,
                    field: 'renewalDate',
                    hidden: true,
                    toolbarSort: 'ASC',
                    toolbarSortByPostFix: [' (earliest)', ' (latest)'],
                    toolbarDefaultSort: false,
                    singleSort: false,
                    render: rowData => (
                        <span title={rowData.renewalDate}>{rowData.renewalDate}</span>
                    )
                },
            );
            customColumns.forEach(customColumn => {
                const defaultColumnIndex = binderStudiesColumns.findIndex(column => column.key === customColumn.key);

                if (defaultColumnIndex !== -1) {
                    if (binderStudiesColumns[defaultColumnIndex].title !== 'Customize' &&
                        binderStudiesColumns[defaultColumnIndex].title !== 'createButton' &&
                        binderStudiesColumns[defaultColumnIndex].title !== 'Name') {
                        if (customColumn.checked) {
                            displayColumns.push(binderStudiesColumns[defaultColumnIndex]);
                        }
                        if (!customColumn.checked && Object.prototype.hasOwnProperty.call(filter, customColumn.key) && filter[customColumn.key].length > 0) {
                            displayColumns.push(binderStudiesColumns[defaultColumnIndex]);
                        }
                    }
                }
            });
            canCreateBinder && displayColumns.push(createButton);
            displayColumns.push(customColumnRecord);
        }
        return displayColumns;
    };
    const handleRowClick = (rowData) => {
        setSelectedRow(rowData);
    };

    const getBinderStudies = async () => {
        setInititalLoading(true);
        await getDashboardDetailsBinderStudiesAdminBinders('name', 'ASC', '', '', paginationdata.limit, paginationdata.offset, 'admin_binder');
        await getBinderCustomColumns(currentUserId, institutionId);
        setInititalLoading(false);
    };

    useEffect(() => {
        getBinderStudies();

    }, []);

    useEffect(() => {
        if (!initialLoading) {
            if (binderStudies.length === 0 && filterRecord.initial && !loadingBinderStudies) {
                setIsZeroState(true);
            }
            else {
                setIsZeroState(false);
            }
            if (!loadingBinderStudies) {
                const rowsData = gatherBinderStudiesTableData(binderStudies);
                const columnsData = buildBinderStudiesColumns(filterRecord.customizedColumns, filterRecord.filter);
                setRows(rowsData);

                if (isDraftView) {
                    const [currentBinder] = rowsData.filter(row => row.id === draftBinderId);
                    if (currentBinder) {
                        setRowData({ ...currentBinder });
                    } else {
                        setRowData({ id: draftBinderId });
                    }
                    setIsDrawerOpen(true);
                }

                setColumns(columnsData);
                setPagination(prevState => ({ ...prevState, totalCount: binderStudiesTotalCount }));
            }
        }

    }, [binderStudies, binderStudiesTotalCount, pinnedBinderIdsState, filterRecord.customizedColumns, filterRecord.filter, initialLoading, loadingBinderStudies]);

    useEffect(() => {
        if (!isEmpty(binderCustomColumns)) {
            setFilterRecord(prevState => ({
                ...prevState,
                customizedColumns: binderCustomColumns
            }));
        }
    }, [binderCustomColumns]);


    const onFilterChange = (filterRecords = filterRecord, pagination = paginationdata) => {
        if (filterRecords && !filterRecords.initial) {
            let updatedColumns;
            setFilterRecord(filterRecords);
            if (filterRecords.customizedColumns && filterRecords.customizedColumns.length > 0) {
                const selectedFilters = Object.keys(filterRecords.filter).filter(key => filterRecords.filter[key].length > 0);

                updatedColumns = filterRecords.customizedColumns.map(column => {
                    if (
                        (selectedFilters.includes(column.key) ||
                            (column.key === 'activation_date' && selectedFilters.includes('activationDate')) ||
                            (column.key === 'renewal_date' && selectedFilters.includes('renewalDate'))) &&
                        !column.checked
                    ) {
                        return { ...column, checked: true };
                    } else {
                        return column;
                    }
                });
                setFilterRecord({ ...filterRecords, customizedColumns: updatedColumns });

                setColumns(buildBinderStudiesColumns(updatedColumns, filterRecords.filter));
                debouncedHandleBinderCustomColumnsCall(currentUserId, institutionId, updatedColumns);
            }
            let queryText = filterRecords ? filterRecords.search : '';
            let sortField = filterRecords.sort.key;
            let sortOrder = filterRecords.sort.key === 'renewalDate' ? (filterRecords.sort.value === 'ASC' ? 'DESC' : 'ASC') : filterRecords.sort.value;
            let filters = filterRecords.filter;

            getDashboardDetailsBinderStudiesAdminBinders(sortField, sortOrder, queryText, filters, pagination.limit, pagination.offset, 'admin_binder');
        }
    };

    const showZeroStateForFilter = (
        (Object.values(filterRecord.filter).length > 0 || Object.values(filterRecord.search).length > 0) &&
        binderStudies.length === 0
    );

    const renderZeroStateComponent = () => !initialLoading && binderStudies.length === 0 && !Object.values(filterRecord.filter).find(f => f.length) && isZeroState;

    return (
        <Fragment>
            {
                renderZeroStateComponent() && canCreateBinder && (
                    bindersInitialStateV4('Administrative', createBinderFunction)
                )
            }

            {
                renderZeroStateComponent() && !canCreateBinder && (
                    bindersInitialStateV4NoAccess('Administrative')
                )
            }

            {
                !renderZeroStateComponent() && (
                    <StudyUsersTeamTable
                        onFilterUpdate={onFilterChange}
                        filterRecord={filterRecord}
                        setFilterRecord={setFilterRecord}
                        rows={rows}
                        columns={columns}
                        pagination={paginationdata}
                        setPagination={setPagination}
                        onChangePagination={(pagination) => onFilterChange(filterRecord, pagination)}
                        dataCy="combinedBindersStudies"
                        handleRowClick={handleRowClick}
                        selectedRow={selectedRow}
                        setSelectedRow={setSelectedRow}
                        isRemoveAllowed={false}
                        isEditAllowed={false}
                        footerLabel='Binders'
                        isLoadingTable={loadingBinderStudies || initialLoading}
                        tableName="admin binders"
                        showFilterPills={true}
                        dashboardCreateButton={true}
                        pageSizeOption={[25, 50, 100]}
                        showZeroStateForFilter={showZeroStateForFilter}
                    />
                )
            }
            <Conditional condition={isDrawerOpen}>
                <CreateBinder rowData={rowData} isOpen={isDrawerOpen} handleOnClose={closeCreateBinder} />
            </Conditional>
        </Fragment>
    );


}

export default connect(
    (state, props) => {

        const binderStudies = lodash.get(state, 'dashboard.bindersStudyAdminBinders', []);
        const binderStudiesTotalCount = lodash.get(state, 'dashboard.binderStudiesCountAdminBinders', []);

        const loadingBinderStudies = lodash.get(state, 'dashboard.loadingBinderStudiesAdminBinders', true);


        const binderStudiesSponsors = lodash.get(state, 'dashboard.binderStudiesSponsorsAdminBinders', []);
        const binderStudiesSiteNumbers = lodash.get(state, 'dashboard.binderStudiesSiteNumbersAdminBinders', []);
        const binderStudiesBinderTypes = lodash.get(state, 'dashboard.binderStudiesBinderTypesAdminBinders', []);
        const binderStudiesContacts = lodash.get(state, 'dashboard.binderStudiesContactsAdminBinders', []);
        const binderStudiesPrincipalInvestigators = lodash.get(state, 'dashboard.binderStudiesPrincipalInvestigatorsAdminBinders', []);
        const binderStudiesSites = lodash.get(state, 'dashboard.binderStudiesSitesAdminBinders', []);
        const binderStudiesCros = lodash.get(state, 'dashboard.binderStudiesCrosAdminBinders', []);
        const binderStudiesDepartments = lodash.get(state, 'dashboard.binderStudiesDepartmentsAdminBinders', []);
        const binderStudiesDiseaseGroups = lodash.get(state, 'dashboard.binderStudiesDiseaseGroupsAdminBinders', []);


        const institutionId = lodash.get(state, 'me.institution.id', false);
        const currentUserId = lodash.get(state, 'me.id', false);
        const canCreateBinder = createNewBinderPredicate(state);
        const binderCustomColumns = lodash.get(state, 'dashboard.customColumns', null);
        const pinnedBinderIds = lodash.get(state, 'dashboard.pinnedBinderIds', []);

        return {
            binderStudies,
            currentUserId,
            institutionId,
            binderCustomColumns,
            binderStudiesTotalCount,
            binderStudiesSponsors,
            binderStudiesSiteNumbers,
            binderStudiesBinderTypes,
            binderStudiesContacts,
            binderStudiesPrincipalInvestigators,
            binderStudiesSites,
            binderStudiesCros,
            binderStudiesDepartments,
            binderStudiesDiseaseGroups,
            pinnedBinderIds,
            loadingBinderStudies,
            canCreateBinder,
        };
    },
    { getDashboardDetailsBinderStudiesAdminBinders, handleBinderCustomColumns, getBinderCustomColumns, setBinderPinAction }
)(AdministrativeBinders);
